import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AuthMode = 'login' | 'signup';

@Injectable({
  providedIn: 'root' // Provided in the root injector, available app-wide
})
export class ModalService {
  // BehaviorSubject to hold the current visibility state (false = closed)
  private modalVisibility = new BehaviorSubject<boolean>(false);
  // BehaviorSubject to hold the initial mode when opened ('login' or 'signup')
  private initialAuthMode = new BehaviorSubject<AuthMode>('login');

  // Observable for components to subscribe to visibility changes
  modalVisibility$ = this.modalVisibility.asObservable();
  // Observable for the modal component to know which form to show initially
  initialAuthMode$ = this.initialAuthMode.asObservable();

  constructor() { }

  openModal(mode: AuthMode = 'login') {
    console.log('Opening modal with mode:', mode); // Debugging log
    this.initialAuthMode.next(mode); // Set the mode first
    this.modalVisibility.next(true); // Then open the modal
  }

  closeModal() {
    this.modalVisibility.next(false);
  }
}